import { SiteCodes } from './siteCodes'

export enum GuestPriceKeys {
  JaycarAu = 'Guest_prices_JRAU',
  JaycarNz = 'Guest_prices_JRNZ',
  RTM = 'Guest_prices_RTAU',
}

export const getGuestPriceKey = (siteCode?: string): GuestPriceKeys => {
  if (siteCode === SiteCodes.JaycarNz) {
    return GuestPriceKeys.JaycarNz
  }

  if (siteCode === SiteCodes.RTM) {
    return GuestPriceKeys.RTM
  }

  return GuestPriceKeys.JaycarAu
}
